import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import HttpRoutingService from "../../shared/services/httpRoutingService";
import { API } from "../../shared/apiRoutes";
import { PushNotificationProps, PushNotificationRes, EmailNotificationRes, EmailNotificationProps, UpdateEmailNotificationProps, UpdatePushNotificationProps, EmailNotificationResRows } from "../../components/settings/notificationSettings/notificationSettingsModule";

interface initialState {
    emailNotifications: { value: EmailNotificationResRows[], count: number }
}

const initialState: initialState = {
    emailNotifications: { value: [], count: 0 }
}

//Method to dispatch convertToReadableFormat api call
export function convertToReadableFormat(input: string) {
    // Split the input string by underscores
    const words = input.split('_');
    // Map over each word, converting the first letter to uppercase and the rest to lowercase
    const formattedWords = words.map(word => {
        // Convert the word to lowercase and capitalize the first letter
        return word.charAt(0) + word.slice(1).toLowerCase();
    });
    // Join the formatted words with spaces
    return formattedWords.join(' ');
}

export const getPushNotificationRedux = createAsyncThunk('notificationSetiings/getPushNotification', ({ storeId, data }: PushNotificationProps) => {
    const url = HttpRoutingService?.replaceUrl(API?.getPushNotification, { storeId: storeId })
    return HttpRoutingService?.getMethod<PushNotificationRes>(url, data)
})

export const getEmailNotificationRedux = createAsyncThunk('notificationSetiings/getEmailNotification', ({ storeId, data }: EmailNotificationProps) => {
    const url = HttpRoutingService?.replaceUrl(API?.getEmailNotification, { storeId: storeId })
    return HttpRoutingService?.getMethod<EmailNotificationRes>(url, data, "v1/")
})


export const updatePushNotificationRedux = createAsyncThunk('notificationSetiings/updatePushNotification', ({ storeId, id, data }: UpdatePushNotificationProps) => {
    const url = HttpRoutingService?.replaceUrl(API?.updatePushNotification, { storeId: storeId, id: id })
    return HttpRoutingService?.putMethod<PushNotificationRes>(url, {}, data, "v2/")
})

export const updateEmailNotificationRedux = createAsyncThunk('notificationSetiings/updateEmailNotification', ({ id, data }: UpdateEmailNotificationProps) => {
    const url = HttpRoutingService?.replaceUrl(API?.updateEmailNotification, { id: id })
    return HttpRoutingService?.putMethod<{ success: boolean }>(url, data, {}, "v1/")
})

export const notificationSlice = createSlice({
    name: "notification",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getEmailNotificationRedux?.fulfilled, (state, action) => {
                let { offset } = action?.meta?.arg?.data
                state.emailNotifications.count = action.payload.response.count
                if (action?.payload?.response?.rows) {
                    let emailData = action?.payload?.response?.rows
                    // ?.map((item) => {
                    //     let data = { ...item }
                    //     data.isEnableNotification = item?.isActive
                    //     data.corrected_code = convertToReadableFormat(item?.templateName)
                    //     return data
                    // })
                    state.emailNotifications.value = (offset > 0 ? [...state.emailNotifications.value, ...emailData] : emailData)
                }
            })
    }
})

export default notificationSlice?.reducer